<template>
    <div class="form-group">
        <label v-if="label">{{label}}</label>
        <div class="row">
            <div class="col-md-3">
                <select class="form-control" name="day" @change="onDayChange" v-model="model.day">
                    <option value="">{{Lang.get('messages.day')}}</option>
                    <option v-for="(index , day) in days" v-if="index > 1" :value="day">{{day}}</option>
                </select>
                <small class="form-text text-danger" v-if="errors&&errors['day']"
                       v-text="errors['day'][0]" />
            </div>
            <div class="col-md-5">
                <select class="form-control" name="month" @change="onMonthChange" v-model="model.month">
                    <option value="">{{Lang.get('messages.month')}}</option>
                    <option v-for="(month, index) in getMonths" :value="index + 1">{{month}}</option>
                </select>
                <small class="form-text text-danger" v-if="errors&&errors['month']"
                       v-text="errors['month'][0]" />
            </div>
            <div class="col-md-4">
                <select class="form-control" name="year" @change="onYearChange" v-model="model.year">
                    <option value="">{{Lang.get('messages.year')}}</option>
                    <option v-for="year in getYears" :value="year">{{year}}</option>
                </select>
                <small class="form-text text-danger" v-if="errors&&errors['year']"
                       v-text="errors['year'][0]" />
            </div>
            <div class="col col-md-8">
                <small class="form-text text-danger" v-if="errors&&errors[name]" v-text="errors[name][0]"/>
                <input type="hidden" v-model="getBirthDate" :id="name" :name="name">
            </div>
        </div>
    </div>
</template>

<script>

    import AdmissionUsers from "@api/admission_user.api";

    export default {
        props: {
            label: {
                type: String
            },
            model: {
                type: [Object, Array],
                required: true
            },
            name: {
                type: String,
                required: true,
            },
            disabled: {
                type: Boolean,
            },
            errors: {
                type: [Object, Array],
            },

        },
        data() {
            return {
                months         : [],
                days           : 32,
                years          : [],
                selected_day   : '',
                selected_month : '',
                selected_year  : '',
                birthDate      : '',
            }
        },
        watch: {
            model() {
                //reset input value if empty
                this.model.day   = this.model.day || "";
                this.model.month = this.model.month || "";
                this.model.year  = this.model.year || "";
                this.model.birth_of_date = this.getBirthDate || "";
                if (this.model.hasOwnProperty('id')) {
                    this.selected_year  = this.model.year;
                    this.selected_day   = this.model.day;
                    this.selected_month = this.model.month;
                    this.birthDate      = this.model.birth_of_date;
                }
               if(this.model.day == '' && this.model.month == '' && this.model.year == ''){
                   this.model.birth_of_date ='';
               }

            },
            getBirthDate() {
                if (this.selected_day != '' && this.selected_month != '' && this.selected_year != '') {
                    AdmissionUsers.getAgeValue(this.getBirthDate).then((data) => {
                        this.model.age = data.data.age;
                        this.model.birth_of_date = this.getBirthDate;
                        this.$emit('finish', data.data.age);
                    });
                }
            }
        },
        methods: {
            getCurrentYear() {
                return new Date().getFullYear();
            },
            onDayChange(event) {
                var val = event.target.value;
                if (val < 10) {
                    val = '0' + val;
                }
                this.selected_day = val;
            },
            onMonthChange(event) {
                var val = event.target.value;
                if (val < 10) {
                    val = '0' + val;
                }
                this.selected_month = val;
            },
            onYearChange(event) {
                this.selected_year = event.target.value;
            },
        },
        computed: {
            getMonths() {
                var theMonths = ["January", "February", "March", "April", "May",
                    "June", "July", "August", "September", "October", "November", "December"];
                for (var i = 0; i < 12; i++) {
                    this.months.push(theMonths[i]);
                }
                return this.months;
            },
            getYears() {
                const year = new Date().getFullYear();//get current year
                var arr_years = Array.from({length: year - 1969}, (value, index) => 1970 + index);
                this.years = arr_years.reverse();
                return this.years;
            },
            getBirthDate() {
                this.birthDate = this.selected_year + '-' + this.selected_month + '-' + this.selected_day;
                return this.birthDate;
            }
        }
    };
</script>
<style>

</style>